import { Map } from 'immutable';

const initialState = Map({

});

export default initialState;
